// --------------------
// Static header (fallback)
// --------------------
const NewHeaderData = [
  { title: "Home", link: "/index" },
  { title: "About Us", link: "/page/about-us" },
  { title: "Gallery Album", link: "/page/gallery&album" },
  { title: "Blog", link: "/page/blog" },

  // Dynamic services submenu will override this using "key"
  {
    title: "Our Services",
    key: "services", // IMPORTANT: Hook matches this
  },

  { title: "Our Products", link: "/page/products" },
  { title: "F&Q", link: "/page/f&q" },
  { title: "Contact Us", link: "/page/contact-simple" },
];

export default NewHeaderData;

// --------------------
// Translation-support version
// --------------------
export const getTranslatedHeaderData = (t) => [
  {
    title: t("menu.home", "Home"),
    link: "/index",
  },
  {
    title: t("menu.about", "About Us"),
    link: "/page/about-us",
  },
  {
    title: t("gallery_page.title", "Gallery Album"),
    link: "/page/gallery&album",
  },
  {
    title: t("menu.blogs", "Blog"),
    link: "/page/blog",
  },

  // Dynamic services list will be injected here
  {
    title: t("menu.services", "Our Services"),
    key: "services", // <-- MUST MATCH useHeaderData
  },

  {
    title: t("menu.porducts", "Our Products"),
    link: "/page/products",
  },
  {
    title: t("menu.faq", "F&Q"),
    link: "/page/f&q",
  },
  {
    title: t("menu.contact", "Contact Us"),
    link: "/page/contact-simple",
  },
];
